import role from './permission/role'
import authority from './permission/authority'
import { App } from 'vue'

/**
 * 全局自定义指令注册
 *
 */
function index(Vue:App<Element>) {
  /**
   * 角色校验
   */
  Vue.directive('role', role)
  /**
   * 权限校验
   */
  Vue.directive('authority', authority)
}

export default index
